import React, { Component } from 'react'
import Slider from 'react-slick'

import { customMaxWidth } from '../../../../utils/responsiveUtils'

import PreviousArrow from '../../../Icons/FranchisePageIcons/IcLeftArrow'
import NextArrow from '../../../Icons/FranchisePageIcons/IcRightArrow'

import TestimonialDescriptionImageItem from './TestimonialDescriptionImageItem'
import './index.global.scss'
import {
  StarsAboutIbCricketSection,
  StarsAboutIbCricketContainer,
  SliderContainer,
  PrevArrowSection,
  NextArrowSection,
  TestimonialsSvgContainer
} from './styledComponents'

class TestimonialSlick extends Component {
  constructor(props) {
    super(props)
    this.state = {
      testimonialIndex: 0,
      testimonialMaxIndexLimit: 1
    }
  }
  componentDidMount() {
    const { testimonialsList } = this.props
    if (customMaxWidth(1101)) {
      // TODO: At this break point 1100, In the slick we need to change the number of cards to be displayed for proper alignment.
      // eslint-disable-next-line
      this.setState({
        testimonialMaxIndexLimit: testimonialsList.length - 1
      })
    } else {
      // eslint-disable-next-line
      this.setState({
        testimonialMaxIndexLimit: testimonialsList.length - 2
      })
    }
  }

  next = () => {
    this.slider.slickNext()
  }
  previous = () => {
    this.slider.slickPrev()
  }
  dragging = e => {
    e.preventDefault()
  }

  renderTestimonials = testimonialsData =>
    testimonialsData.map(testimonial => (
      <TestimonialDescriptionImageItem
        id={testimonial.index}
        country={testimonial.country}
        testimonialDescription={testimonial.testimonialDescription}
        testimonialName={testimonial.testimonialName}
      />
    ))

  testimonialStopSliding = index => {
    this.setState({
      testimonialIndex: index
    })
  }

  render() {
    const { testimonialsList } = this.props
    const { testimonialIndex, testimonialMaxIndexLimit } = this.state
    const testimonialsSlickSettings = {
      dots: false,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 10000,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      draggable: true,
      afterChange: this.testimonialStopSliding,
      responsive: [
        {
          breakpoint: 602,
          settings: {
            dots: false,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            draggable: true
          }
        },
        {
          breakpoint: 1101,
          settings: {
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            draggable: true
          }
        }
      ]
    }
    return (
      <StarsAboutIbCricketSection>
        <StarsAboutIbCricketContainer>
          <SliderContainer>
            <PrevArrowSection
              id="experimental-marketing-testimonials-prev-arrow"
              onClick={this.previous}
            >
              <TestimonialsSvgContainer disableArrow={testimonialIndex === 0}>
                <PreviousArrow />
              </TestimonialsSvgContainer>
            </PrevArrowSection>
            <Slider
              ref={c => {
                this.slider = c
              }}
              className="ExperimentalTestimonialsSlickSection"
              {...testimonialsSlickSettings}
            >
              {this.renderTestimonials(testimonialsList)}
            </Slider>
            <NextArrowSection
              onClick={
                testimonialIndex >= testimonialMaxIndexLimit ? null : this.next
              }
              id="experimental-marketing-testimonials-next-arrow"
            >
              <TestimonialsSvgContainer
                disableArrow={testimonialIndex >= testimonialMaxIndexLimit}
              >
                <NextArrow />
              </TestimonialsSvgContainer>
            </NextArrowSection>
          </SliderContainer>
        </StarsAboutIbCricketContainer>
      </StarsAboutIbCricketSection>
    )
  }
}

export default TestimonialSlick



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/IbCricketAtIpl2019/TestimonialSlick/index.js